export default (api) => ({
    activitiesSorted: (params) => api.post('/data-navigator/views/activities-sorted', params),
    transitionsSorted: (params) => api.post('/data-navigator/views/transitions-sorted', params),
    variantsOver: (params) => api.post('/data-navigator/views/variants-over', params),
    variantsSorted: (params) => api.post('/data-navigator/views/variants-sorted', params),
})
